
  const inventoryReservationDashboard = {
    path: "/inventoryReservation/dashboard",
    name: "inventoryReservationDashboard",
    component: () => import(/* webpackChunkName: "inventory_reservation_dashboard" */ "@/components/inventoryReservation/InventoryReservationDashboard.vue"),
    meta: { authorize: ['Administrator', 'Manager', 'Factory'], requiresAuth: true }
  };

export default inventoryReservationDashboard;
